import { render, staticRenderFns } from "./StatisticsCardWithImages.vue?vue&type=template&id=8648a022&scoped=true&"
import script from "./StatisticsCardWithImages.vue?vue&type=script&lang=js&"
export * from "./StatisticsCardWithImages.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsCardWithImages.vue?vue&type=style&index=0&id=8648a022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8648a022",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../landing-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VChip,VImg,VSpacer})
